import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const StyledToolbar = styled('div')`
  padding: 12px 24px;
  background-color: ${COLOR.white};
  display: flex;
  align-items: center;
  justify-content: center;

  .toolbar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1200px;
    width: 100%;
  }

  .toolbar-loading {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    max-width: 1200px;
    width: 100%;

    .toolbar-loading-spinner {
      color: ${COLOR.blue600};
    }
  }

  .toolbar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    .refresh-button {
      width: 32px;
      height: 32px;
      padding: 4px;
      border-radius: 8px;
      border: 1px solid ${COLOR.indigo[16]};

      .refresh-icon {
        width: 20px;
        height: 20px;
        color: ${COLOR.secondary[8]};
      }
    }
  }

  /* @media screen and (min-width: 1440px) {
    padding: 12px 80px;
  }

  @media screen and (min-width: 1920px) {
    padding: 12px 320px;
  } */
`;

const StyledItemVoice = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
`;

export { StyledToolbar, StyledItemVoice };
